import React from "react";
import { useDispatch } from "react-redux";
import {
  promoteToAgentAction,
  showErrorMessage,
  showSuccessMessage,
} from "../../../../actions";
import { resolveErrorMessage } from "../../../../util";
import ActionDialog from "../../ActionDialog";
import { Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import LoadingSpinner from "../../LoadingSpinner";

const PromoteToAgentDialog = ({
  open,
  onClose,
  user,
  fetchUser,
  onPromoted,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const promoteToAgent = async () => {
    setLoading(true);
    try {
      await promoteToAgentAction({ editedUserId: user.id });
      dispatch(showSuccessMessage("app.edit.sucesfully"));
      await fetchUser();
      onPromoted();
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      dispatch(showErrorMessage(errorMessage));
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ActionDialog
      title="app.confirmations"
      open={open}
      onClose={onClose}
      onAccept={promoteToAgent}
      textConfirm="app.ok"
      disableConfirmButton={loading}
    >
      {loading ? (
        <LoadingSpinner
          message={<FormattedMessage id="app.loading.updating" />}
        />
      ) : (
        <>
          <Typography variant="body1">
            <FormattedHTMLMessage id="app.confirm.promoteToAgent" />
          </Typography>
        </>
      )}
    </ActionDialog>
  );
};

export default PromoteToAgentDialog;
